const check = () => {
  if (!window.jsVars) throw new Error('no jsVars found');
}

export function mainColor() {
  check();
  return window.jsVars.newspaperPresenterColor;
}

export function newspaperLandingPageUrl() {
  check();
  return window.jsVars.newspaperLandingPageUrl;
}

export function newspaperName() {
  check();
  return window.jsVars.newspaperName;
}

export function widgetContactsEnabled() {
  check();
  return (window.jsVars.widgetContactsEnabled === "true") ? true : false;
}

export function widgetHeight() {
  check();
  return window.jsVars.widgetHeight;
}
